import * as React from "react";
const SvgMinus = (props) => /* @__PURE__ */ React.createElement("svg", { width: 13, height: 4, viewBox: "0 0 13 4", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12.5 3.15998V0.927979H0.5V3.15998H12.5Z", fill: "#5CB60E" }));
export default SvgMinus;
